export enum ContentTaskSortingTypeGq {
  APPROVED = 'APPROVED',
  APPROVED_DATE = 'APPROVED_DATE',
  ACTION = 'ACTION',
  URL = 'URL',
  TOTAL_VOLUME = 'TOTAL_VOLUME',
  TOTAL_TRAFFIC = 'TOTAL_TRAFFIC',
  KEYWORD = 'KEYWORD',
  KEYWORD_VOLUME = 'KEYWORD_VOLUME',
  KEYWORD_TRAFFIC = 'KEYWORD_TRAFFIC',
  KEYWORD_RANK = 'KEYWORD_RANK',
  KEYWORD_IN_CONTENT = 'KEYWORD_IN_CONTENT',
  KEYWORD_IN_H_1 = 'KEYWORD_IN_H_1',
  KEYWORD_IN_TITLE = 'KEYWORD_IN_TITLE',
  TAG_GROUP = 'TAG_GROUP',
  KEYWORD_ENGLISH = 'KEYWORD_ENGLISH',
  STATUS_CODE = 'STATUS_CODE',
}
